import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore } from '@pascal/pascal-core/shared/core/store';
import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';

import { gameStore } from '../../store/gameStore';
import { doBetStore } from '../../store/doBetStore';
import { winningStore } from '../../store/winningStore';
import { autoBetStore } from '../../store/autoBetStore';
import { RESULT_SHOWING_TIME } from '../../enums/constants';

const GameResultCircles = observer(() => {
  const { isBetsClosed } = gameStore;
  const { autoBetCount } = autoBetStore;
  const { isAnimationOn } = userSettingsStore;
  const { roundFinResult, roundIsFin } = doBetStore;
  const { winningAmount, demoWinningAmount } = winningStore;
  const [oddResult, setOddResult] = useState(null);

  const outOdd = (odd = 1) => {
    if (isAnimationOn) {
      let step;
      let newOdd;
      const percent = 0.01;
      const intervalTime = RESULT_SHOWING_TIME * percent;
      const intervalId = setInterval(() => {
        setOddResult((prev) => {
          if (prev < odd) {
            step = (odd * percent).toFixed(3);
            if (prev + +step >= odd) {
              clearInterval(intervalId);
              return odd;
            }
            newOdd = prev + +step;
          } else {
            step = (prev * percent).toFixed(3);
            if (prev - +step <= odd) {
              clearInterval(intervalId);
              return odd;
            }
            newOdd = prev - +step;
          }

          if (prev === null) {
            return 1;
          }
          return +newOdd.toFixed(2);
        });
      }, intervalTime);
    } else {
      setOddResult(odd);
    }
  };

  const isWin = useMemo(() => {
    if (applicationStore.isDemo) {
      return demoWinningAmount;
    }
    return winningAmount;
  }, [winningAmount, demoWinningAmount]);

  useEffect(() => {
    if (roundFinResult) {
      outOdd(roundFinResult);
    } else {
      outOdd();
    }
  }, [outOdd, roundFinResult]);

  const winOrLoseClassName = useMemo(() => {
    return isWin ? 'win' : 'lose';
  }, [isWin]);

  return (
    <div
      className={`crazy-target-circle ${
        (roundFinResult && (!isBetsClosed || roundIsFin) && !autoBetCount) ||
        (autoBetCount && roundIsFin)
          ? winOrLoseClassName
          : ''
      }`}
    >
      x{oddResult <= 1 ? '1.00' : oddResult.toFixed(2)}
    </div>
  );
});

export default GameResultCircles;
